import { render, staticRenderFns } from "./DataCollectionStatsContainer.vue?vue&type=template&id=7099c7b8&scoped=true&"
import script from "./DataCollectionStatsContainer.vue?vue&type=script&lang=js&"
export * from "./DataCollectionStatsContainer.vue?vue&type=script&lang=js&"
import style0 from "./DataCollectionStatsContainer.vue?vue&type=style&index=0&id=7099c7b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7099c7b8",
  null
  
)

export default component.exports